import { Divider } from '@/components/base/divider'
import { NavLink } from '@/components/layout/navlink'
import { Outlet } from 'react-router'

export const Layout = () => {
  return (
    <>
      <div className="flex flex-col gap-4">
        <div className="flex flex-row gap-8 items-center">
          <NavLink to="/asset-types">Asset types</NavLink>
          <NavLink to="/assets">Assets</NavLink>
          <NavLink to="/packages">Packages</NavLink>
          <NavLink to="/extra-items">Extra items</NavLink>
          <NavLink to="/vehicles">Vehicles</NavLink>
          <NavLink to="/cases">Cases</NavLink>
        </div>
        <Divider />
        <Outlet />
      </div>
    </>
  )
}
